namespace ui
{
	export namespace Form
	{

		export type	FormMethod		= 'GET' | 'POST' | 'PATCH' | 'PUT' | 'OPTIONS' | 'DELETE';

		export interface	IFormParameter	{[key: string]: any; }

		export interface IFormDescriptor extends ui.base.IBaseHTMLElementDescriptor
		{
			action:							string;
			method?:						FormMethod;
			submit:							( method: FormMethod, url: string, parameter: IFormParameter ) => void;
			invalid?:						( inputs: BasicInputField[] ) => void;
			static?:						boolean;
			notSwitchable?:			boolean;
			editButtonContext?:	ui.Context;
			autocomplete?: "on" | "off";
		}

		export class Form
			extends ui.base.HTMLPresentation<HTMLFormElement>
		{

			public		Buttons:			{[key: string]: Button};

			public readonly	Descriptor:		IFormDescriptor;

			private		m_Inputs:			{[key: string]: BasicInputField};
			private		m_Static:			boolean;
			private		m_EditButton:	Button|null;
			private		m_OnSubmit:		(() => void)|null;

			public constructor( descriptor: IFormDescriptor )
			{
				super( 'form' );

				this.m_Inputs			= {};
				this.m_Static			= false;
				this.Descriptor		= descriptor;
				this.m_OnSubmit		= null;
				this.m_EditButton	= descriptor.notSwitchable ? null : new Button(
					{
						classes: [ 'form-switch' , 'form-switch-sticky', 'pull-right', 'hidden' ],
						style: this.Descriptor.editButtonContext || 'default',
						title: ui.$$.span().addClass( 'fas fa-pencil-alt' )
					},
				);

				this.Buttons			=
				{
					cancel: new Button(
						{
							behaviour: 'button',
							on:
							{
								click: () =>
								{
									this.reset();

									if ( this.m_EditButton )
									{
										$( this.m_EditButton.getElement() ).removeClass( 'hidden' );
										this.Switch();
									}
								},
							},
							style: 'danger',
							title: 'cancel'
						},
					),
					submit: new Button(
						{
							behaviour: 'submit',
							style: 'success',
							title: 'submit'
						},
					)
				};
			}

			public submit(): void
			{
				this.m_Root.trigger( 'submit' );
			}

			public Initialize(): void
			{
				super.Initialize( this.Descriptor );

				if ( this.Descriptor.static )
				{
					this.m_Static	= true;

					if ( this.m_EditButton )
					{
						$( this.m_EditButton.getElement() ).removeClass( 'hidden' );
					}
				}

				if (this.Descriptor.autocomplete)
				{
					this.attr('autocomplete', this.Descriptor.autocomplete);
				}

				this.m_OnSubmit = (): boolean =>
				{
					const parameter: IFormParameter						= {};
					const invalids: ui.Form.BasicInputField[]	= new Array();
					const valid: boolean											= this.isValid( parameter, invalids );

					if ( valid )
					{
						this.Descriptor.submit( this.Descriptor.method || 'GET', this.Descriptor.action, parameter );

						if ( this.m_EditButton )
						{
							$( this.m_EditButton.getElement() ).removeClass( 'hidden' );
							this.Switch();
						}
					}
					else
					{
						if ( this.Descriptor.invalid ) { this.Descriptor.invalid( invalids ); }
					}

					return false;
				};

				this.m_Root.submit(
					( e: any ) =>
					{
						e.preventDefault();
						e.stopPropagation();

						for ( const key in this.m_Inputs )
						{
							if ( this.m_Inputs[ key ] === undefined )
							{
								continue;
							}

							this.m_Inputs[ key ].onSave();
						}

						if ( this.m_OnSubmit )
						{
							return this.m_OnSubmit.call( this );
						}

						return false;
					}
				);
				$( this.Buttons.submit.getElement() ).on(
					'click',
					() =>
					{
						for ( const key in this.m_Inputs )
						{
							if ( this.m_Inputs[ key ] === undefined )
							{
								continue;
							}

							this.m_Inputs[ key ].onSave();
						}

						if ( this.m_OnSubmit )
						{
							return this.m_OnSubmit.call( this );
						}

						return false;
					}
				);
			}

			public isValid( _parameter: {[key: string]: any}, _invalids: BasicInputField[] ): boolean
			{
				let valid = true;

				for ( const i in this.m_Inputs )
				{
					if ( this.m_Inputs[ i ] === undefined )
					{
						continue;
					}

					const input = this.m_Inputs[ i ];

					if ( !input.CheckIfValid() )
					{
						valid = false;

						input.remClass( 'has-success has-warning' );
						input.addClass( 'has-error' );

						_invalids.push( input );
					}
					else
					{
						input.remClass( 'has-error has-warning' );
						input.addClass( 'has-success' );
					}

					const name = input.Name;
					if ( name ) { _parameter = ui.utils.Object.ExtractFillObject( _parameter, name, input ); }
				}

				return valid;
			}

			public Input(): {[key: string]: BasicInputField<HTMLElement>};
			public Input( input: BasicInputField<HTMLElement>|Array<BasicInputField<HTMLElement>> ): void;

			public Input(
				input?: BasicInputField<HTMLElement>|Array<BasicInputField<HTMLElement>>
			): {[key: string]: BasicInputField<HTMLElement>}|void
			{
				if ( input )
				{
					input = input instanceof Array ? input : [ input ];

					input.forEach(
						( _input ) =>
						{
							this.m_Inputs[ _input.Descriptor.name || _input.UUID ] = _input;

							_input.Static( this.m_Static );
						},
					);

					return;
				}

				return this.m_Inputs;
			}

			public clear(): void
			{
				this.m_Inputs = {};
			}

			public get(name: string): BasicInputField<HTMLElement>
			{
				return this.m_Inputs[name];
			}

			public removeInput( input: BasicInputField<HTMLElement> ): Form
			{
				if ( input )
				{
					for ( const i in this.m_Inputs )
					{
						if ( input.isSame( this.m_Inputs[ i ] ) )
						{
							delete this.m_Inputs[ i ];

							break;
						}
					}
				}

				return this;
			}

			public rebuild( root: JQuery<HTMLElement>|ui.base.BaseHTMLElement ): Form
			{
				this.remove().empty().appendTo( root );

				this.Initialize();

				if ( this.m_EditButton )
				{
					this.append( $( this.m_EditButton.getElement() ) );

					// TODO Statt hard-coded top muss von parent abhängen, derzeit keine Möglichkeit aus Zeitgründen
					$( this.m_EditButton.getElement() ).css( 'top', '90px' )
					.on(
						{
							click: () =>
							{
								if ( this.m_EditButton )
								{
									$( this.m_EditButton.getElement() ).addClass( 'hidden' );
									this.Switch();
								}
							},
						},
					);
				}

				return this;
			}

			/**
			 * Resets all registered input fields.
			 *
			 * @return void
			 */
			public reset(): void
			{
				for ( const i in this.m_Inputs )
				{
					if ( this.m_Inputs[ i ] === undefined )
					{
						continue;
					}

					this.m_Inputs[ i ].reset();
				}
			}

			public Switch(): void
			{
				this.m_Static = !this.m_Static;

				for ( const i in this.m_Inputs )
				{
					if ( this.m_Inputs[ i ] === undefined )
					{
						continue;
					}

					this.m_Inputs[ i ].Static( this.m_Static );
				}
			}

		}

	}
}
